import { render, staticRenderFns } from "./BoolUnionTopBarIcon.vue?vue&type=template&id=55491951&"
import script from "./BoolUnionTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./BoolUnionTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports